import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

const MemberTaskDetails = ({ token }) => {
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [tat, setTat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState({
    externalUserIdName: '',
    externalUserIdNamePre: '',
    externalUserIdNew: '',
    userTypeNameNew: '',
    dueDateFromNew: '',
    dueDateToNew: ''
  });

  // Helper to get query params
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const userId = getQueryParam('userId');
        const status = getQueryParam('status');
        const caseManagerOrQueueId = getQueryParam('externalUserId');
        const dueDateFrom = getQueryParam('startDate');
        const dueDateTo = getQueryParam('endDate');
        const userType = getQueryParam('userType');
        if (!userId || !status || !caseManagerOrQueueId || !dueDateFrom || !dueDateTo || !userType) {
          setError('Missing required query parameters in URL');
          setLoading(false);
          return;
        }
        // Build API URL for userwise
        const params = new URLSearchParams({
          CaseManagerOrQueueId: caseManagerOrQueueId,
          DueDateFrom: dueDateFrom,
          DueDateTo: dueDateTo,
          UserType: userType,
          UserID: userId,
          Status: status
        }).toString();
        const response = await fetch(`http://localhost:5199/api/Task/userwise?${params}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!response.ok) throw new Error('Failed to fetch userwise task data');
        const data = await response.json();
        // Use data.taskStatusList if present and is array, else fallback to data if array
        if (data && Array.isArray(data.taskStatusList)) {
          setTableData(data.taskStatusList);
        } else if (Array.isArray(data)) {
          setTableData(data);
        } else {
          setTableData([]);
        }
        // Set breadcrumb info if present
        setBreadcrumb({
          externalUserIdName: data.externalUserIdName || '',
          externalUserIdNamePre: data.externalUserIdNamePre || '',
          externalUserIdNew: data.externalUserIdNew || '',
          userTypeNameNew: data.userTypeNameNew || '',
          dueDateFromNew: data.dueDateFromNew || '',
          dueDateToNew: data.dueDateToNew || ''
        });

        // Fetch TAT API with token
        const tatParams = new URLSearchParams({
          UserID: userId,
          Status: status
        }).toString();
        const tatResponse = await fetch(`http://localhost:5199/api/Task/tat?${tatParams}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (tatResponse.ok) {
          const tatData = await tatResponse.json();
          setTat(tatData);
        } else {
          setTat(null);
        }
      } catch (err) {
        setError(err.message);
        setTableData([]);
        setTat(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [location.search, token]);

  return (
    <div className="container mt-4">
      {/* Breadcrumb navigation */}
      <div className="breadcrumb" style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
        {breadcrumb.externalUserIdNamePre && (
          <Link
            to={`/task/user-task-chart?externalUserId=${encodeURIComponent(breadcrumb.externalUserIdNew)}&userType=${encodeURIComponent(breadcrumb.userTypeNameNew)}&startDate=${encodeURIComponent(breadcrumb.dueDateFromNew)}&endDate=${encodeURIComponent(breadcrumb.dueDateToNew)}`}
            className="breadcrumb-item breadcrumb-first"
            style={{
              textDecoration: 'none',
              color: '#007bff',
              background: '#f5f5f5',
              padding: '6px 16px',
              borderRadius: '4px 0 0 4px',
              border: '1px solid #dee2e6',
              fontWeight: 'bold',
              marginRight: 0
            }}
          >
            {breadcrumb.externalUserIdNamePre}
          </Link>
        )}
        {breadcrumb.externalUserIdName && (
          <span
            className="breadcrumb-item"
            style={{
              background: '#e9ecef',
              padding: '6px 16px',
              borderRadius: '0 4px 4px 0',
              borderTop: '1px solid #dee2e6',
              borderBottom: '1px solid #dee2e6',
              borderRight: '1px solid #dee2e6',
              fontWeight: 'bold',
              color: '#343a40'
            }}
          >
            {breadcrumb.externalUserIdName}
          </span>
        )}
      </div>
      <h2>Member Task Details</h2>
      {loading && <div>Loading...</div>}
      {error && <div className="text-danger">{error}</div>}
      {tat && (
        <div className="mb-3">
          <strong>TAT:</strong> {JSON.stringify(tat)}
        </div>
      )}
      {!loading && !error && tableData.length === 0 && (
        <div>No data available for this user and status.</div>
      )}
      {!loading && !error && tableData.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Task ID</th>
                <th>Type of visit completed</th>
                <th>NCM</th>
                <th>Due Date</th>
                <th>Status</th>
                <th>Member Name</th>
                <th>Member Id</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, idx) => (
                <tr key={idx}>
                   <td style={{ borderLeft: '4px solid #d9534f', fontWeight: 'bold' }}>
                     <span style={{ color: '#007bff' }}>{row.task_Id}</span>
                   </td>
                  <td>{row.task}</td>
                  <td>{row.createdBy}</td>
                  <td>{row.due_Date ? new Date(row.due_Date).toLocaleDateString() : ''}</td>
                  <td>{row.status}</td>
                  <td>{row.memberName}</td>
                  <td>{row.memberId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MemberTaskDetails;
